import type {
  WebCollectionFindListOutputDto,
  WebCollectionFindOneOutputDto,
  WebContentFindOneCollectionsDeepDto,
  WebLiveChannelListItemCollectionOutputDto,
} from '@bldsoft/ovp-api-types'
import type { Collection } from '@setplex/tria-api'
import { toDate } from '../../tools'
import { formatContentType } from '../../utils/contentType'
import type { ApiCollection } from './index.h'

const isLiveChannelListItemCollection = (
  collection: ApiCollection
): collection is WebLiveChannelListItemCollectionOutputDto =>
  !('description' in collection)

export const formatListItem = ({
  id,
  title,
}: WebLiveChannelListItemCollectionOutputDto): Collection => ({
  id,
  title,
  createDate: new Date(0),
})

export const formatFromList = ({
  id,
  title,
  description,
  horizontalImage,
  background,
  createDate,
}: WebCollectionFindListOutputDto): Collection => ({
  id,
  title,
  description,
  horizontalImage,
  background: [...background],
  createDate: toDate(createDate),
})

export const formatFromOne = ({
  id,
  title,
  description,
  horizontalImage,
  background,
  contentTypes,
  seoMetadata,
}: WebCollectionFindOneOutputDto): Collection => ({
  id,
  title,
  description,
  horizontalImage,
  background: [...background],
  contentTypes: formatContentType(contentTypes),
  seoMetadata,
  createDate: new Date(0),
})

export const formatFromContentDeep = ({
  id,
  title,
  description,
  horizontalImage,
  background,
}: WebContentFindOneCollectionsDeepDto): Collection => ({
  id,
  title,
  description,
  horizontalImage,
  background: [...background],
  createDate: new Date(0),
})

export const format = (collection: ApiCollection): Collection => {
  if (isLiveChannelListItemCollection(collection)) {
    return formatListItem(collection)
  }

  if ('createDate' in collection) {
    return formatFromList(collection)
  }

  return formatFromOne(collection)
}
